<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addDialogShow()">新建</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="userId" label="用户ID" align="center"></el-table-column>
                <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
                <el-table-column prop="logo" label="LOGO" align="center">
                    <template slot-scope="scope">
                        <img :src="scope.row.logo" alt="" style="width: 50px;height: 50px;" v-if="scope.row.logo">
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="agentName" label="代理名称" align="center"></el-table-column>
                <el-table-column prop="custName" label="自定义名称" align="center"></el-table-column>
                <el-table-column prop="loginWel" label="欢迎语" align="center"></el-table-column>
                <el-table-column prop="yongJinRatio" label="佣金比例" align="center"></el-table-column>
                <el-table-column prop="yaoQingUrl" label="邀请链接" align="center"></el-table-column>
                <el-table-column prop="creationTime" label="创建时间" align="center" width="180px"></el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="120px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="editTip(scope.row)">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteTip(scope.row)">删除</el-button>
                </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.current"
                    :page-size="conditionData.size">
                </el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增" width="500px">
            <forms ref="formListAdd" :list="formList" :value="formData" :rules="formRules" :btns="formAddBtns" labelWidth="120px"></forms>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" title="编辑" width="500px">
            <forms ref="formListEdit" :list="formList" :value="formData" :rules="formRules" :btns="formEditBtns" labelWidth="120px"></forms>
        </el-dialog>


        
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {wtlxList,isNewList} from '../../../assets/selectList/index'
import {parseTimeS} from '../../../utils/index'
export default {
    name: 'person',
    components:{
        queryCondition,
        forms
    },
    watch: {
    },
    data () {
        return {
            isAddDialog:false,
            isUpdateDialog:false,

            totalCount:0,
            tableData:[],

            conditionData:{
                userId:'',
                phone:'',
                current:1,
                size:10,
            },
            queryList:[
                {type: "input",label: "手机号:",name: "phone"},
                {type: "input",label: "用户ID:",name: "userId"},
            ],

            formData:{
                logo:'',
                userId:'',
                phone:'',
                agentName:'',
                custName:'',
                loginWel:'',
                yongJinRatio:'',
                yaoQingUrl:'',
            },
            formList:[
                {type: "input",label: "用户ID:",name: "userId"},
                {type: "input",label: "手机号:",name: "phone"},
                {type: "input",label: "头像:",name: "logo"},
                {type: "input",label: "代理名称:",name: "agentName",},
                {type: "input",label: "自定义名称:",name: "custName"},
                {type: "input",label: "欢迎语:",name: "loginWel"},
                {type: "input",label: "佣金比例:",name: "yongJinRatio"},
                {type: "input",label: "邀请链接:",name: "yaoQingUrl"},
            ],
            // 提交规则
            formRules:{
               
            },
            formAddBtns:[
                {name:'确认新增',icon:'el-icon-circle-plus',type:'success',handleClick:this.add},
                {name:'关闭',icon:'el-icon-error',type:'warning',handleClick:this.close}
            ],
            formEditBtns:[
                {name:'确认编辑',icon:'el-icon-edit',type:'success',handleClick:this.edit},
                {name:'关闭',icon:'el-icon-error',type:'warning',handleClick:this.close}
            ],
        }
    },
    created(){
    },
    mounted(){
        this.loadingData();
    },
    methods:{
        addDialogShow(){
            this.isAddDialog = true;
        },
        // table表头样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 加载table数据
        async loadingData() {
            let res  = await api.AgentGetListPage({
                current:this.conditionData.current,
                size:this.conditionData.size,
                userId:this.conditionData.userId,
                phone:this.conditionData.phone,
            });
            this.tableData = res.data.data.records;
            this.totalCount = res.data.data.total;
        },
        // 查询
        selectData(){
            this.conditionData.current = 1;
            this.loadingData();
        },
        // 重置查询
        reset(){
            this.conditionData = {
                userId:'',
                phone:'',
                current:1,
                size:10,
            },
            this.loadingData();
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.current = page;
            this.loadingData();
        },
        // 切换页面条数
        handleSizeChange(size){
            this.conditionData.current = 1;
            this.conditionData.size = size;
            this.loadingData();
        },
        // 新增弹窗
        showAddDialog(e){
            this.isAddDialog = true;
        },
        // 新增方法
        async add(){
            let flag = this.$refs["formListAdd"].validateForm();
            if(!flag){
                return;
            }
            this.formData.userId = parseFloat(this.formData.userId);
            this.formData.yongJinRatio = parseFloat(this.formData.yongJinRatio);
            let res  = await api.AgentCreateAgent(this.formData);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.$refs["formListAdd"].resetFields();
                this.isAddDialog = false;
                this.loadingData();
            }
        },
        isUpdateDialogShow(row){
            this.isUpdateDialog = true;
            this.formData = {
                id:row.id,
                Name:row.name,
                Type:row.type,
                UnderwritingAgency:row.underwritingAgency,
                IsNew:row.isNew,
            }
        },
        // 编辑方法
        async edit(){
            let flag = this.$refs["formListEdit"].validateForm();
            if(!flag){
                return;
            }
            let res  = await api.AgentUpdateAgent(this.formData);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.$refs["formListEdit"].resetFields();
                this.isUpdateDialog = false;
                this.loadingData();
            }
        },
        // 关闭新增和编辑的弹框
        close(){
            if(this.isAddDialog){
                this.isAddDialog = false
            }else if(this.isUpdateDialog){
                this.isUpdateDialog = false
                this.$refs["formListEdit"].resetFields();
            }
        },
        // 删除提示
        deleteRowTip(row){
            this.$confirm('将删除委托主体——'+row.name+', 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteRow(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        // 删除方法
        async deleteRow(row){
            let res  = await api.AgentDeleteAgent({id:row.id});
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },


        editTip(item){
            this.isUpdateDialog = true;
            this.formData = item;
            
        },
        async edit(){
            let res = await api.AgentUpdateAgent(this.formData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '操作成功'
                });  
                this.isUpdateDialog = false;
                this.loadingData();
                this.formData = {
                    id:null,
                    userId:'',
                    phone:'',
                    logo:'',
                    agentName:'',
                    custName:'', 
                    loginWel:'',
                    yongJinRatio:'',
                    yaoQingUrl:'',  
                }
            }
        },


        deleteTip(item){
            this.$confirm('将删除此代理?', '是否继续', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del(item);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async del(item){
            let res = await api.AgentDeleteAgent(item.id);
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
   
</style>
